import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TenantHeadersService } from '../../services/tenant-headers.service';
import { SKIP_REQUEST_MUTATORS } from '../skip-request-mutators/skip-request-mutators.interceptor';

@Injectable()
export class TenantHeaderInterceptor implements HttpInterceptor {
  public constructor(private readonly tenantHeadersService: TenantHeadersService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(SKIP_REQUEST_MUTATORS)) return next.handle(req);

    return next.handle(req.clone({ setHeaders: this.tenantHeadersService.getHeaders() }));
  }
}
